import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { ConcurObjectDataset } from 'app/model/dataset/concur.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ConcurObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class ConcurObjectDatasetAdapter extends TabularTypeDatasetAdapter<ConcurObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: ConcurObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(ConcurObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ConcurObjectDataset): Promise<ConcurObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, ConcurObjectDataset.MODEL);
    }
}
